export default {
    changePokemonButton: "Trocar Pokemon",
    surrenderButton: "Desistir",
    wantToSurrender: "Você quer desistir? (Desistir demais pode levar a uma suspensão!)",
    wantToSurrenderPrivate: "Você quer desistir?",
    searchBattle: "Buscar Batalha",
    searchBattleRanked: "Rank",
    searchBattleCasual: "Casual",
    searchTourneyBattle: (Enemy, round) => `Tourneio ${round} vs ${Enemy} `,
    searchTourneyBattleNotReady: (round) => `Batalha do torneio não está pronta! (${round})`,
    searchBattleNotEnoguh: "Você precisa de 6 Pokemon no seu time!",

    wantToBattleCasual: "Você quer buscar uma batalha casual?",
    wantToBattleRanked: "Você quer buscar uma batalha ranqueada?",
    rankedRequirements: "- Apenas um pokemon com mais de 567 base stats total",
    waitForPlayer: "Aguardando outro jogador...",

    noTeam: "Você não tem um time.",
    TeamFainted: "Busca falhou. Um ou mais dos seus Pokemon estão nocauteados",
    bannedPokemonInTeam: "Busca falhou. Um ou mais dos seus Pokemon estão banidos de batalhas públicas",
    notEnoughPokemon: "Busca falhou. Você precisa de pelo menos 6 Pokemon!",
    userBanned: "Você está banido por:",
    removeFromTeam: "Remover do time",
    info: "Info",

    // battle
    battlePlayerNotAccepted: "O seu oponente perdeu conexão antes que a batalha pudesse começar. Por favor tente novamente.",
    battleCancelled: "A batalha foi cancelada.",
    battleAlreadyEnded: "A batalha já terminou.",
    battleWaitForPlayer: "Aguardando outro jogador...",
    battleMoveUsed: (pokemonName, moveName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span> usou <span class="battle-log-movename" style="color:#ff6374">${moveName}</span>.`,
    battleMoveFailed: "Falhou...",
    battleAttackMissed: (pokemonName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span> errou o ataque.`,
    battleNotEffective: "Isso não foi muito eficaz...",
    battleEffective: "Foi super eficaz!",
    battleNoEffect: "Não tem efeito...",
    battleCriticalHit: "Um golpe crítico!",
    battleNotAwaitingMove: "Este movimento já foi escolhido.",
    battleMultipleHits: (amount) => `${amount} hits!`,
    battleStatUp1: (pokemonName, statName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span>'s ${statName} aumentou.`,
    battleStatUp2: (pokemonName, statName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span>'s ${statName} aumentou bastante!`,
    battleStatUp3: (pokemonName, statName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span>'s ${statName} aumentou drasticamente!`,
    battleStatDown1: (pokemonName, statName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span>'s ${statName} reduziu.`,
    battleStatDown2: (pokemonName, statName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span>'s ${statName} reduziu bastante!`,
    battleStatDown3: (pokemonName, statName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span>'s ${statName} reduziu drasticamente!`,

    // status effects
    battleEnemySleeping: (pokemonName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span> dormiu.`,
    battleEnemyParalysis: (pokemonName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span> foi paralisado.`,
    battleEnemyPoison: (pokemonName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span> foi envenenado.`,
    battleEnemyToxic: (pokemonName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span> foi envenenado severamente.`,
    battleEnemyBurned: (pokemonName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span> foi queimado.`,
    battleIsParalyzed: (pokemonName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span> está paralisado e não consegue se mover.`,
    battleEnemyConfused: (pokemonName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span> ficou confuso`,
    battleEnemyEndConfusion: (pokemonName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span> deixou de estar confuso`,
    battleEnemyEndBurn: (pokemonName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span> deixou de estar queimado`,
    battleEnemyEndParalysis: (pokemonName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span> deixou de estar paralisado`,
    battleEnemyEndPoison: (pokemonName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span> deixou de estar envenenado`,
    battleEnemyFrozen: (pokemonName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span> está congelado`,
    battleIsSleeping: (pokemonName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span> está dormindo e não consegue se mover.`,
    battleConfused: (pokemonName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span> está confuso e se machucou.`,
    battleIsFrozen: (pokemonName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span> está congelado e não consegue se mover.`,
    battleFlinched: (pokemonName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span> recuou e não conseguiu atacar`,
    battleHealed: (pokemonName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span> restaurou o seu HP.`,
    battleWokeUp: (pokemonName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span> acordou.`,
    battleUnthawed: (pokemonName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span> descongelou.`,
    battleRecoilApplied: (pokemonName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span> levou dano de recuo.`,
    battlePoisonDamage: (pokemonName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span> levou dano de envenenamento.`,
    battleBurnDamage: (pokemonName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${pokemonName}</span> levou dano de queimadura.`,
    battlePokemonChanged: (LastPokemonName, CurrentPokemonName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${LastPokemonName}</span> foi trocado por <span class="battle-log-pokemonname" style="color:#63ff78">${CurrentPokemonName}</span>.`,

    battleDisallowSwitching: (trainerName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${trainerName}</span> can't switch out anymore.`,
    battleAllowSwitching: (trainerName) => `<span class="battle-log-pokemonname" style="color:#63ff78">${trainerName}</span> can switch out again.`,


    // field effects
    battleRainEnd: `Parou de chover`,
    battleRainStarted: `Começou a chover`,
    battleHailStarted: `Começou uma tempestade de neve`,
    battleHailDamage: 'Pokemon tomou dano da tempestade de neve.',
    battleHailEnd: 'A tempestade de neve terminou.',
    battleSandstormStarted: "Começou uma tempestade de areia",
    battleSandstormDamage: "Pokemon tomou dano da tempestade de areia.",
    battleSandstormEnd: "A tempestade de areia terminou.",
    battleSunStarted: `O sol brilha forte.`,
    battleSunEnd: `O sol desapareceu.`,

    // user field effect
    battleMistStarted: "Os seus Pokemon foram envolvidos por uma névoa",
    battleMistPrevented: "A névoa previne que stats sejam reduzidos.",
    battleMistEnd: "A névoa se dissipou.",
    battleLightScreenStarted: "Uma tela de luz protege o time do usuário.",
    battleLightScreenEnd: "A tela de luz desapareceu.",
    battleReflectStarted: "O time do usuário está sendo protegido por reflect.",
    battleTailwindStarted: "O vento começou a soprar por trás do time do usuário.",
    battleTailwindEnd: "O vento parou de soprar.",
    battleReflectEnd: "O efeito de reflitir parou.",
    battleTrickRoomStarted: "As dimensões ficaram torcidas.",
    battleTrickRoomEnd: "As dimensões voltaram ao normal.",
    battleHazeUsed: "As mudanças de stats foram resetadas.",

    // battle ended
    BattleWin: "Parabéns, você venceu a batalha!",
    BattleLose: "Você perdeu a batalha!",
    BattleXP: (XP, DOLLAR) => `Todos em seu time ganharam ${XP} XP! Você recebeu $${DOLLAR}!`,
    BattleNoXP: "O seu time não recebeu XP!",

    struggle: "Struggle",

    battleDoesntExist: "Essa batalha não existe!",
    enterSpectateKey: "Chave de espectador:",

    tooManyConcurrentBattles: "Há batalhas demais acontecendo! Por favor tente novamente em 5 minutos!"
};